let categories = [];
let totalCategories = null;

export default function categoryFilter() {
    $('.js-category-filter-form').on('submit', handleFormSubmit);
    $('.js-category-filter-reset').on('click', handleReset);
    $('.js-category-filter-remove').on('click', handleRemoveCategory);
    $('.js-category-filter-all').on('change', handleChangeAllCategory);
    $('.js-category-filter-item').on('change', handleChangeCategory);

    const queryParams = new URLSearchParams(window.location.search);
    const categoriesString = queryParams.get('category');
    categories = categoriesString ? categoriesString.split(',') : [];

    totalCategories = $('.js-category-filter-item').length;
}

function handleFormSubmit(e) {
    e.preventDefault();

    updateCurrentUrlWithNewCategories();
}

function handleReset() {
    categories.splice(0, categories.length);
    updateCurrentUrlWithNewCategories();
}

function handleRemoveCategory(e) {
    const categoryToRemove = $(e.currentTarget).attr('data-value');
    removeCategory(categoryToRemove);

    updateCurrentUrlWithNewCategories();
}

function handleChangeCategory(e) {
    const category = e.currentTarget.value;
    e.currentTarget.checked ? addCategory(category) : removeCategory(category);

    checkAllCategory();
}

function handleChangeAllCategory(e) {
    if (e.currentTarget.checked) {
        $('.js-category-filter-item:checked').prop('checked', false);
        categories.splice(0, categories.length);
    }
}

function checkAllCategory() {
    const allCategoriesSelected = categories.length === 0 || categories.length === totalCategories;
    $('.js-category-filter-all').prop('checked', allCategoriesSelected);
}

function addCategory(category) {
    categories.push(category.trim());
}

function removeCategory(category) {
    const index = categories.indexOf(category);
    if (index > -1) {
        categories.splice(index, 1);
    }
}

function updateCurrentUrlWithNewCategories() {
    const currentUrl = window.location.href.split('?')[0];
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.set('category', categories.join(','));

    window.location.href = `${currentUrl}?${queryParams.toString()}`;
}



// WEBPACK FOOTER //
// ./src/Resources/ui/js/categoryFilter.js